import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { ManufacturerAnnouncementType, CreateManufacturerAnnouncementTypePayload } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<
    UseMutationOptions<unknown, Error, CreateManufacturerAnnouncementTypePayload, ManufacturerAnnouncementType>,
    'mutationKey' | 'mutationFn'
  >;
}

export const useNewManufacturerAnnouncementTypeRequest = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()

  return useMutation<unknown, Error, CreateManufacturerAnnouncementTypePayload, ManufacturerAnnouncementType>(
    [Entities.ManufacturerAnnouncementTypes, 'new'],
    async (payload: CreateManufacturerAnnouncementTypePayload) => {
      const { data } = await api.v1AdminManufacturersAnnouncementsTypesPost(payload)
      return data
    },
    { ...options },
  )
}
